var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c("div", { staticClass: "queryClass" }, [
            !_vm.showdiv
              ? _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px", "margin-right": "1rem" },
                      attrs: { placeholder: "经销商", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.queryByPage()
                        },
                      },
                      model: {
                        value: _vm.queryCondition.agency,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryCondition, "agency", $$v)
                        },
                        expression: "queryCondition.agency",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              [
                !_vm.showdiv
                  ? _c(
                      "vxe-button",
                      {
                        attrs: { status: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryByPage(1)
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    )
                  : _vm._e(),
                !_vm.showdiv
                  ? _c(
                      "vxe-button",
                      {
                        staticClass: "filter-search-item",
                        attrs: { type: "info" },
                        on: { click: _vm.resetForm },
                      },
                      [_vm._v("重置")]
                    )
                  : _vm._e(),
                _c(
                  "vxe-button",
                  { attrs: { type: "warning" }, on: { click: _vm.cb } },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.showdiv ? "收起" : "更多选项") + " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-collapse-transition", [
                _vm.showdiv
                  ? _c("div", [
                      _vm.showdiv
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form",
                                {
                                  staticClass: "UniformCss",
                                  attrs: { "label-width": "70px" },
                                },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 10 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 4 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            { attrs: { label: "经销商" } },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "经销商",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.agency,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "agency",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.agency",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 4 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            { attrs: { label: "申请状态" } },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  attrs: {
                                                    placeholder: "申请状态",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .busStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "busStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.busStatus",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select-option",
                                                    { attrs: { value: "1" } },
                                                    [_vm._v("驳回")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    { attrs: { value: "2" } },
                                                    [_vm._v("结束")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "Mat001",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "经理部总经理待审核"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "Mat002",
                                                      },
                                                    },
                                                    [_vm._v("物料管理员待审核")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 4 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            { attrs: { label: "申请时间" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "date",
                                                  "value-format": "yyyy-MM-dd",
                                                  placeholder: "选择日期",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.queryCondition.endDate
                                                      ? (_vm.data.endDate = "")
                                                      : ""
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .beginDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "beginDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.beginDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 4 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            { attrs: { label: "至" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "date",
                                                  "value-format": "yyyy-MM-dd",
                                                  placeholder: "选择日期",
                                                  "picker-options": {
                                                    disabledDate: function (
                                                      time
                                                    ) {
                                                      return (
                                                        time.getTime() <
                                                        new Date(
                                                          _vm.queryCondition.beginDate
                                                        ) -
                                                          8.64e7
                                                      )
                                                    },
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.endDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "endDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.endDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("br"),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "padding-bottom": "10px",
                                  },
                                  attrs: { slot: "footer" },
                                  slot: "footer",
                                },
                                [
                                  _c(
                                    "vxe-button",
                                    {
                                      attrs: { type: "info" },
                                      on: { click: _vm.resetForm },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                  _c(
                                    "vxe-button",
                                    {
                                      attrs: { status: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.queryByPage(1)
                                        },
                                      },
                                    },
                                    [_vm._v("搜索")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              attrs: {
                loading: _vm.listLoading,
                align: _vm.allAlign,
                "max-height":
                  _vm.$store.state.app.height - 130 < 500
                    ? 500
                    : _vm.$store.state.app.height - 130,
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "scroll-y": { enabled: false },
                "row-config": { isHover: true },
                data: _vm.tableData,
              },
              on: { "sort-change": _vm.listSortMethod },
            },
            [
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "org_SHORT_NAME", title: "经销商名称" },
              }),
              _c("vxe-column", {
                attrs: { field: "sq_TIME", title: "申请时间", width: "150" },
              }),
              _c("vxe-column", {
                attrs: { field: "sq_AMOUNT", title: "申请物料总计(元)" },
              }),
              _c("vxe-column", {
                attrs: { field: "sp_AMOUNT", title: "审批物料总计(元)" },
              }),
              _c("vxe-column", {
                attrs: { field: "audit_STATUS", title: "申请状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.billsSTATUS(row.audit_STATUS))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "signed_TIME",
                  title: "签收时间",
                  width: "150",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "操作",
                  width: "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "operate" },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.detailFun(row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.size,
              total: _vm.pagination.total,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.changePage },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入Excel",
            visible: _vm.uploadDialog,
            width: "22%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.uploadDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "faultAdd", attrs: { loading: _vm.importLoading } },
            [
              _c("div", { staticClass: "model-box" }, [
                _c(
                  "a",
                  {
                    staticClass: "load-buttom",
                    attrs: {
                      href: "/file/活动集客导入模板.xlsx",
                      download: "",
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-download" }),
                    _vm._v("下载示例模板"),
                  ]
                ),
              ]),
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "",
                    multiple: "",
                    "http-request": _vm.upload,
                    "before-upload": _vm.uploadBefore,
                    "file-list": _vm.fileList,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v("直接导入已填好的Excel列表，仅支持XLS/XLSX")]
                  ),
                ]
              ),
              _vm.errorList.length > 0
                ? _c(
                    "div",
                    { staticClass: "err-box" },
                    [
                      _c(
                        "el-link",
                        { attrs: { icon: "el-icon-warning", type: "danger" } },
                        [
                          _vm._v(
                            "Excel导入出错，请检查错误行，然后将错误行重新导入"
                          ),
                        ]
                      ),
                      _vm._l(_vm.errorList, function (item) {
                        return _c(
                          "div",
                          { key: item.row },
                          [
                            _c("el-link", { attrs: { type: "danger" } }, [
                              _vm._v(
                                "第" +
                                  _vm._s(item.row) +
                                  "行" +
                                  _vm._s(item.error)
                              ),
                            ]),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择导出项",
            visible: _vm.dialogVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.ExportItem,
                callback: function ($$v) {
                  _vm.ExportItem = $$v
                },
                expression: "ExportItem",
              },
            },
            [
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("导出全部")]),
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("导出当前页")]),
              _c("el-radio", { attrs: { label: 2, disabled: _vm.disabled } }, [
                _vm._v("导出已选择项"),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: {
                    status: "primary",
                    loading: _vm.outExcelButtonLocading,
                  },
                  on: { click: _vm.exportXlsxFun },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }